import { Clock, Check } from 'lucide-react';
import { content } from '../content';

const ServicesGrid = () => {
  const services = [
    {
      title: content.services.initialSession.title,
      duration: content.services.initialSession.duration,
      location: content.services.initialSession.location,
      description: content.services.initialSession.description,
      features: content.services.initialSession.features,
    },
    {
      title: content.services.followUpSession.title,
      duration: content.services.followUpSession.duration,
      location: content.services.followUpSession.location,
      description: content.services.followUpSession.description,
      features: content.services.followUpSession.features,
    },
    {
      title: content.services.exclusiveMembership.title,
      duration: 'Ongoing Support',
      location: content.services.exclusiveMembership.location,
      description: content.services.exclusiveMembership.description,
      features: [
        'Priority in-home scheduling',
        'Discounted session rates',
        'Continuous support between sessions',
        'Flexible scheduling for busy professionals',
        'Concierge-level personalized care'
      ],
    },
  ];

  return (
    <section id="services" className="py-20 lg:py-28 bg-[#D5D2C5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl serif font-light text-gray-900 mb-6">
            {content.services.heading}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {content.services.subheading}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-10">
          {services.slice(0, 2).map((service) => (
            <div
              key={service.title}
              className="bg-white rounded-2xl p-10 shadow-sm border border-gray-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="space-y-6">
                <div>
                  <h3 className="text-3xl serif font-medium text-gray-900 mb-3">
                    {service.title}
                  </h3>
                  <div className="flex items-center text-purple-600 space-x-2 mb-2">
                    <Clock size={18} />
                    <span className="text-sm font-medium uppercase tracking-wide">
                      {service.duration}
                    </span>
                  </div>
                  <p className="text-sm text-gray-500 italic">
                    {service.location}
                  </p>
                </div>

                <p className="text-gray-600 leading-relaxed text-lg">
                  {service.description}
                </p>

                <ul className="space-y-3">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <div className="mt-1 flex-shrink-0">
                        <Check className="text-green-600" size={18} strokeWidth={2.5} />
                      </div>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Exclusive Membership - Centered */}
        <div className="max-w-3xl mx-auto mb-10">
          <div className="bg-white rounded-2xl p-10 shadow-sm border border-gray-200 hover:shadow-lg transition-all duration-300">
            <div className="space-y-6">
              <div>
                <h3 className="text-3xl serif font-medium text-gray-900 mb-3">
                  {services[2].title}
                </h3>
                <div className="flex items-center text-purple-600 space-x-2 mb-2">
                  <Clock size={18} />
                  <span className="text-sm font-medium uppercase tracking-wide">
                    {services[2].duration}
                  </span>
                </div>
                <p className="text-sm text-gray-500 italic">
                  {services[2].location}
                </p>
              </div>

              <p className="text-gray-600 leading-relaxed text-lg">
                {services[2].description}
              </p>

              <ul className="space-y-3">
                {services[2].features.map((feature, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <div className="mt-1 flex-shrink-0">
                      <Check className="text-green-600" size={18} strokeWidth={2.5} />
                    </div>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Additional Services - Private Yoga & Virtual Support */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
            <h3 className="text-2xl serif font-medium text-gray-900 mb-3">
              {content.services.privateYoga.title}
            </h3>
            <p className="text-sm text-gray-500 italic mb-4">{content.services.privateYoga.location}</p>
            <p className="text-gray-600 leading-relaxed">
              {content.services.privateYoga.description}
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
            <h3 className="text-2xl serif font-medium text-gray-900 mb-3">
              {content.services.virtualSupport.title}
            </h3>
            <p className="text-sm text-gray-500 italic mb-4">{content.services.virtualSupport.location}</p>
            <p className="text-gray-600 leading-relaxed">
              {content.services.virtualSupport.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;